import { render } from "./EmailLogsList.vue?vue&type=template&id=ec0e3c6c"
import script from "./EmailLogsList.vue?vue&type=script&lang=js"
export * from "./EmailLogsList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./EmailLogsList.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_0bcf977f%2Fpackages%2Fbo%2Fsrc%2Fviews%2Femail_logs%2FEmailLogsList.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__